import type { RichTextCustomElement } from '../../../types.js'

export const textAlign: RichTextCustomElement = {
  name: 'alignment',
  Button: '@payloadcms/richtext-slate/client#TextAlignElementButton',
  Element: false,
}
